import { render, staticRenderFns } from "./MarketGroupContainer.vue?vue&type=template&id=7c255120"
import script from "./MarketGroupContainer.vue?vue&type=script&lang=js"
export * from "./MarketGroupContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports